// Maps a category (by index) to one of the 12 brand category swatch tokens
// (--ss-cat-01..12), used for category tiles and image placeholders.
export function categorySwatch(index = 0) {
  const n = (((index % 12) + 12) % 12) + 1; // 1..12
  return `var(--ss-cat-${String(n).padStart(2, '0')})`;
}
